import React, { Fragment } from 'react';
import { Button } from 'components';
import { isIOS, isMobileOnly } from 'react-device-detect';
import classNames from 'classnames';
import './BottomNav.scss';

const BottomNav = ({
  leftButton, rightButton, onLeftClick, onRightClick, altStyle, rtl,
}) => {
  const classes = classNames({
    'nw-bottom-nav': true,
    'nw-bottom-nav--alt': altStyle,
    'nw-bottom-nav--oneButton': !leftButton || !rightButton,
    'nw-bottom-nav--rtl': rtl,
    'nw-bottom-nav--ios': isMobileOnly && isIOS,
  });

  return (
    <div className={classes}>
      {
        altStyle ? (
          <Fragment>
            {leftButton && <Button value={leftButton} onButtonClick={onLeftClick} isOutlineButton />}
            {rightButton && <Button value={rightButton} onButtonClick={onRightClick} isPrimary />}
          </Fragment>
        )
          : (
            <Fragment>
              {leftButton && <button type="button" onClick={onLeftClick}>{leftButton}</button>}
              {rightButton && <button type="button" onClick={onRightClick}>{rightButton}</button>}
            </Fragment>
          )
      }

    </div>
  );
};

export default BottomNav;
